.filterContainer {
    width: 250px;
}